import React from 'react';
import * as ReactDOM from "react-dom";
import Game from "../Game";
import {withRouter} from "../withRouter";
import ModeratorGameReview from "./ModeratorGameReview";
import {NavLink} from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";

class ModeratorGames extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoaded: false,
            error: null,
            isLoadedGamesInReview: false,
            isLoadedGamesReadyForReview: false,
            isLoadedGamesUpdateInReview: false,
            isLoadedAllGames: false,
            readyForReview: [],
            inReview: [],
            updateInReview: [],
            userId: null,
            loginError: null,
            allGames: [],
        };
    }

    searchGames(e){
        e.preventDefault();
        fetch(process.env.REACT_APP_API_URL + "/customer/game/search/" + e.target.keyword.value, {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    this.setState({
                        isLoadedAllGames: true,
                        allGames: result
                    });
                },

                (error) => {
                    console.log(error);

                    this.setState({
                        isLoadedAllGames: true,
                        error
                    });
                }
            )
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    if (result.role.name !== 'moderator' && result.role.name !== 'admin') {
                        this.setState({
                            isLoaded: true,
                            loginError: 'unauthorized'
                        });
                    } else {
                        this.setState({
                            isLoaded: true,
                            userId: result.id
                        });
                    }
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error,
                    });
                }
            );

        let statusInReview = ['in_review'];
        fetch(process.env.REACT_APP_API_URL + "/moderator/games?filters[status]="+JSON.stringify(statusInReview), {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedGamesInReview: true,
                        inReview: result.data
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoadedGamesInReview: true,
                        error
                    });
                }
            )

        let statusUpdateInReview = ['update_in_review'];
        fetch(process.env.REACT_APP_API_URL + "/moderator/games?filters[status]="+JSON.stringify(statusUpdateInReview), {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedGamesUpdateInReview: true,
                        updateInReview: result.data
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoadedGamesUpdateInReview: true,
                        error
                    });
                }
            )


        let statusReadyForReview = ['ready_for_review'];
        fetch(process.env.REACT_APP_API_URL + "/moderator/games?filters[status]="+JSON.stringify(statusReadyForReview), {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedGamesReadyForReview: true,
                        readyForReview: result.data
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoadedGamesReadyForReview: true,
                        error
                    });
                }
            )

        fetch(process.env.REACT_APP_API_URL + "/moderator/games?sort=id", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoadedAllGames: true,
                        allGames: result.data
                    });
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    this.setState({
                        isLoadedAllGames: true,
                        error
                    });
                }
            )
    }

    render() {
        const { userId, allGames, isLoadedAllGames, isLoaded, loginError, isLoadedGamesInReview, inReview, isLoadedGamesReadyForReview, readyForReview, isLoadedGamesUpdateInReview, updateInReview  } = this.state;

        let gamesInReview = [];
        let gamesReadyForReview = [];
        let gamesUpdateInReview = [];
        let allGamesFormatted = [];

        if (userId) {

            if (!isLoadedGamesInReview) {
                gamesInReview = <div>Loading...</div>;
            } else {
                gamesInReview = (
                    <div id="root">
                        <div className="table-responsive" style={{
                            overflowX: "auto",
                            width: "100%",
                            whiteSpace: "nowrap"
                        }}>
                            <table className="table table-striped table-hover">
                                <thead className="thead-light">
                                <tr>
                                    <th scope="col">#</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Publisher</th>
                                    <th scope="col">Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {inReview.map(game => (
                                    <tr id={game.name.concat(game.id.toString())}>
                                        <th scope="row">{game.id}</th>
                                        <td>{game.name}</td>
                                        <td>{game.publisher.name}</td>
                                        <td>
                                            <a className="btn btn-danger"
                                               href={'/moderator/' + userId.toString() + '/game/' + game.id.toString()}>Open</a>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            }

            if (!isLoadedGamesUpdateInReview) {
                gamesUpdateInReview = <div>Loading...</div>;
            } else {
                gamesUpdateInReview = (
                    <div>
                        <div className="table-responsive" style={{
                            overflowX: "auto",
                            width: "100%",
                            whiteSpace: "nowrap"
                        }}>
                            <table className="table table-striped table-hover">
                        <thead className="thead-light">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Publisher</th>
                            <th scope="col">Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {updateInReview.map(game => (
                            <tr id={game.name.concat(game.id.toString())}>
                                <th scope="row">{game.id}</th>
                                <td>{game.name}</td>
                                <td>{game.publisher.name}</td>
                                <td>
                                    <a className="btn btn-danger"
                                       href={'/moderator/' + userId.toString() + '/game/' + game.id.toString()}>Open</a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                        </div>
                    </div>
                );
            }

            if (!isLoadedGamesReadyForReview) {
                gamesReadyForReview = <div>Loading...</div>;
            } else {
                gamesReadyForReview = (
                    <div id="root">
                        <div className="table-responsive" style={{
                            overflowX: "auto",
                            width: "100%",
                            whiteSpace: "nowrap"
                        }}>
                            <table className="table table-striped table-hover">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Publisher</th>
                                <th scope="col">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {readyForReview.map(game => (
                                <tr id={game.name.concat(game.id.toString())}>
                                    <th scope="row">{game.id}</th>
                                    <td>{game.name}</td>
                                    <td>{game.publisher.name}</td>
                                    <td>
                                        <a class="btn btn-danger" href={'/moderator/' + userId.toString() + '/game/' + game.id.toString()}>Open</a>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>
                    </div>
                );
            }

            if (!isLoadedAllGames) {
                allGamesFormatted = <div>Loading...</div>;
            } else {
                allGamesFormatted = (
                    <div id="root">
                        <div className="table-responsive" style={{
                            overflowX: "auto",
                            width: "100%",
                            whiteSpace: "nowrap"
                        }}>
                        <table className="table table-striped table-hover">
                            <thead className="thead-light">
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">Name</th>
                                <th scope="col">Publisher</th>
                                <th scope="col">Action</th>
                            </tr>
                            </thead>
                            <tbody>
                            {allGames.map(game => (
                                <tr id={game.name.concat(game.id.toString())}>
                                    <th scope="row">{game.id}</th>
                                    <td>{game.name}</td>
                                    <td>{game.publisher.name}</td>
                                    <td>
                                        <a className="btn btn-danger"
                                           href={'/moderator/' + userId.toString() + '/game/' + game.id.toString()}>Open</a>

                                        <a className="btn btn-outline-danger ms-1"
                                           href={'/moderator/' + userId.toString() + '/game/' + game.id.toString()}>Preview</a>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                        </div>
                    </div>
                );
            }
        }

        const { navigate } = this.props;

        if (loginError) {
            navigate('/account');
        }

        let content = null;

        if (isLoaded && userId) {
            content = <div>
                <div className="row alert alert-light">
                    <div className="col-sm alert alert-danger">
                        <h3>In review</h3>
                        {gamesInReview}
                    </div>

                    <div className="col-sm alert alert-warning ms-1">
                        <h3>Update in review</h3>
                        {gamesUpdateInReview}
                    </div>

                    <div className="col-sm alert alert-success ms-1">
                        <h3>Ready for review</h3>
                        {gamesReadyForReview}
                    </div>
                </div>

                <h3>Others</h3>
                <form onSubmit={this.searchGames.bind(this)}>
                    <input class="form-control" type="text" name="keyword" placeholder="Keyword..."/>
                    <br/>
                    <input class="btn btn-outline-success" type="submit" value="Search"/>
                    <br/>
                </form>
                <br/>
                <div class="alert alert-success">
                {allGamesFormatted}
                </div>

                <br/>
                {userId
                    ? <NavLink
                        to={"/moderator/" + userId.toString()}
                        className="btn btn-outline-primary"
                    >
                        Recent activity
                    </NavLink>
                    : <hr/>
                }
            </div>;
        } else {
            content = <h1>Loading...</h1>
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>
    }
}

export default withRouter(ModeratorGames);
